import { render } from "./proveedor.vue?vue&type=template&id=04346e1c"
import script from "./proveedor.vue?vue&type=script&lang=js"
export * from "./proveedor.vue?vue&type=script&lang=js"

import "./proveedor.vue?vue&type=style&index=0&id=04346e1c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__